import React, { useEffect, useState } from "react";
import TableCustom from "../../../components/table/tableCustom";
import TableRowCommon from "../../../components/table/TableRowCommon";
import { NavigateFunction, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { dateTimeToView } from "../../../utils/date.utils";
import { routeName } from "../../../routes/routeName";
import { icons } from "../../../assets/icons/icons";
import CustomStatus from "../../../components/chip/CustomStatus";
import { FiberManualRecord, SearchOutlined } from "@mui/icons-material";
import NavigateListCustom from "../../../components/navigation/NavigationListCustom";
import InputTextField from "../../../components/input/inputTextField";
import { debouncedApiCall } from "../../../utils/app.utils";
import InputNewRangePicker from "../../../components/input/inputRankPicker";
import FilterSelect from "../../../components/select/filterSelect";
import { allStatusAdvisorRequestUtil } from "../../../utils/statusRequest";
import { MenuItem, Typography } from "@mui/material";
import moment from "moment";
import { advisorRequestApi } from "../../../api/advisor-request/advisor-request.api";
import { useTranslation } from "react-i18next";

const TransferAdvisorRequestHistory = () => {
  const { t } = useTranslation();
  const navigate: NavigateFunction = useNavigate();
  const dispatch = useDispatch();

  const [data, setData] = useState<any>({});

  const [page, setPage] = useState<number>(1);
  const [pageLimit, setPageLimit] = useState<number>(10);
  const [totalItems, setTotalItems] = useState<number>(0);
  const [sortBy, setSortBy] = useState<string>("");
  const [sortType, setSortType] = useState<string>("ASC");

  const [search, setSearch] = useState<string>("");
  const [inputValueSearch, setInputValueSearch] = useState({
    keyword: "",
    consultation_type: "",
    status: "",
  });

  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const [selectedDateRange, setSelectedDateRange] = useState<string[]>([]);
  const handleRangeDate = (value: any) => {
    setSelectedDateRange(value);
    setStartDate(moment(value[0]).format("YYYY-MM-DD"));
    setEndDate(moment(value[1]).format("YYYY-MM-DD"));
  };

  const handleClearRangeDate = () => {
    setSelectedDateRange([]);
    setStartDate("");
    setEndDate("");
  };

  const headCells = [
    {
      id: "old_advisor",
      width: 125,
      disablePadding: false,
      align: "start",
      label: t("อาจารย์ที่ปรึกษาปัจจุบัน"),
    },
    {
      id: "new_advisor",
      disablePadding: false,
      width: 125,
      align: "start",
      label: t("อาจารย์ที่ปรึกษาใหม่ที่ต้องการ"),
    },
    {
      id: "created_date",
      disablePadding: false,
      align: "start",
      width: 50,
      label: t("วันที่ส่งคำร้อง"),
    },
    {
      id: "status",
      disablePadding: false,
      align: "center",
      width: 100,
      label: t("สถานะ"),
    },
    {
      id: "action",
      disablePadding: false,
      align: "center",
      width: 25,
      label: "action",
    },
  ];

  const handleStatus = (status: string) => {
    if (status === "รอพิจารณา") { // i18n-ignore
      return "warning";
    } else if (status === "ตอบรับเป็นที่ปรึกษา") { // i18n-ignore
      return "success";
    } else if (status === "ปฏิเสธคำขอ") { // i18n-ignore
      return "error";
    } else if (status === "รออาจารย์ที่ปรึกษาพิจารณาคำร้อง") { // i18n-ignore
      return "warning";
    } else if (status === "รออาจารย์ที่ปรึกษาใหม่พิจารณาคำร้อง") { // i18n-ignore
      return "warning";
    } else if (status === "อนุมัติคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา") { // i18n-ignore
      return "info";
    } else if (status === "สิ้นสุดการเป็นอาจารย์ที่ปรึกษา") { // i18n-ignore
      return "error";
    } else if (status === "อาจารย์ที่ปรึกษาใหม่ปฏิเสธคำขอ") { // i18n-ignore
      return "error";
    } else {
      return "default";
    }
  };

  const renderData = (objData: any, no: any) => {
    no = page * pageLimit - pageLimit + no + 1;
    const {
      id_advisor_request,
      first_name_old,
      last_name_old,
      first_name_new,
      last_name_new,
      created_date,
      status_request,
    } = objData;

    const objRenderData = {
      key: id_advisor_request,
      id: no,
      obj: objData,
      columns: [
        {
          option: "TEXT",
          align: "start",
          label: first_name_old + " " + last_name_old,
        },
        {
          option: "TEXT",
          align: "start",
          label: first_name_new
            ? first_name_new
            : "-" + " " + last_name_new
            ? last_name_new
            : "-",
        },
        {
          option: "TEXT",
          align: "start",
          disablePadding: true,
          label: created_date ? dateTimeToView(created_date) : "",
        },
        {
          option: "TEXT",
          align: "center",
          // label: status_request,
          label: (
            <CustomStatus
              label={t(status_request)}
              type="outlined"
              color={handleStatus(status_request)}
              icon={<FiberManualRecord />}
              width="250px"
            />
          ),
        },
        {
          option: "TEXT",
          align: "center",
          label: (
            <div
              style={{
                display: "flex",
                textAlign: "center",
                justifyContent: "center",
              }}
            >
              <img
                onClick={() => {
                  navigate(
                    routeName.student.TransferAdvisor +
                      `/history/${id_advisor_request}/detail`
                  );
                }}
                src={icons.eye}
                alt="eye"
                style={{ cursor: "pointer" }}
              />
            </div>
          ),
        },
      ],
    };
    return <TableRowCommon {...objRenderData} />;
  };

  const handleChangeValueSearch = (name: string, value: any) => {
    setInputValueSearch((prev: any) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const getAdvisorRequestByUser = async () => {
    let query: any = {
      page: page,
      limit: pageLimit,
      sortBy: sortBy,
      sortType: sortType,
      sdate: startDate,
      edate: endDate,
      status: inputValueSearch.status,
    };

    if (search) query = { ...query, search: search };

    const res = await advisorRequestApi.getHistoyAdvisorRequest(query);
    const data = res.data;
    if (data.status < 300) {
      setData(data.data?.items);
      setTotalItems(data.data?.meta?.totalItems || 0);
    } else {
      setData([]);
    }
  };

  useEffect(() => {
    getAdvisorRequestByUser();
  }, [
    page,
    pageLimit,
    sortBy,
    sortType,
    search,
    inputValueSearch,
    startDate,
    endDate,
  ]);

  return (
    <div className="h-auto">
      {/* breadcrumbs */}
      <NavigateListCustom
        navigateData={[
          {
            name: t("อาจารย์ที่ปรึกษา"),
            key: "1",
            pathName: routeName.student.chooseAdvisor,
          },
          {
            name: t("ประวัติการส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษา"),
            key: "2",
            pathName: routeName.student.TransferAdvisor + `/history`,
          },
        ]}
      />

      <section className="w-full mb-12">
        <Typography variant="h3">
          {t("ประวัติการส่งคำร้องขอเปลี่ยนอาจารย์ที่ปรึกษาวิทยานิพนธ์")}
        </Typography>
      </section>

      <div className="w-full grid grid-cols-12 gap-4 mt-[40px]">
        <article className="w-full col-span-12 lg:col-span-3  md:col-span-3  sm:col-span-12">
          <InputTextField
            startAdornment={<SearchOutlined />}
            placeholder={t("ค้นหาชื่อ - นามสกุล/เลขประจำตัวเจ้าหน้าที่")}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              debouncedApiCall({
                searchItem: e.target.value,
                setItem: setSearch,
              })
            }
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
          <InputNewRangePicker
            value={selectedDateRange}
            onchange={handleRangeDate}
            onClear={handleClearRangeDate}
            allowClear
          />
        </article>

        <article className="w-full col-span-12 lg:col-span-3 md:col-span-3 sm:col-span-12">
          <FilterSelect
            value={inputValueSearch.status ?? ""}
            labelId="status-id"
            selectId="status-select-id"
            options={[
              {
                id_status: "",
                status_name: t("ทุกสถานะ"),
              },
              ...allStatusAdvisorRequestUtil.map((item) => ({
                id_status: item,
                status_name: item,
              })),
            ].map((list, index) => (
              <MenuItem value={list.id_status} key={index + 1}>
                {t(list.status_name)}
              </MenuItem>
            ))}
            onchange={(e: React.ChangeEvent<HTMLInputElement>) =>
              handleChangeValueSearch("status", e.target.value)
            }
          />
        </article>
      </div>

      <section className="w-full mt-10">
        <TableCustom
          tableMinWidth={650}
          tableFixedWidth
          customScroll
          page={page}
          pageLimit={pageLimit}
          sortBy={sortBy}
          sortType={sortType}
          headCells={headCells}
          rowCount={totalItems}
          rowsData={
            data &&
            data.length > 0 &&
            data.map((data: any, i: any) => {
              return renderData(data, i);
            })
          }
          onSort={() => {}}
          setPageLimit={(value: number) => setPageLimit(value)}
          setPage={(value: number) => setPage(value)}
        />
      </section>
    </div>
  );
};

export default TransferAdvisorRequestHistory;
